module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v("Praise for"), _c('br'), _c('em', [_vm._v("Swimming in the Volcano:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A stunning tour de force ... In some of the most brilliantly sinuous and seductive prose being written today, Shacochis summons the spirits of guilt and innocence, of love and hate, of white and black, [and] of America and the Third World.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—"), _c('em', [_vm._v("Newsday")]), _vm._v(" (New York)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“"), _c('em', [_vm._v("Swimming in the Volcano")]), _vm._v(" is sharp, fluid storytelling ... [with] scenes of harsh power and immense range.... Shacochis has created an absorbing group of protagonists, and ... remarkable language [that] maintains the highest level of emotional melodrama amid an ever-thickening backdrop of political implication.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—"), _c('em', [_vm._v("San Francisco Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Big, lush ... rich ... "), _c('em', [_vm._v("Swimming in the Volcano")]), _vm._v(" is a mural, a tapestry, a gallery. Shacochis projects a series of nightmarish, psychotropic, fatally beautiful impressions, [creating] an indelible impression of the state of mind that is St. Catherine.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', [_vm._v("San Diego Union Tribune")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A dark novel reminiscent of "), _c('em', [_vm._v("Nostromo")]), _vm._v(" in its meditations on how the innocent become swept up in political foment, and of Faulkner in its rolling sentence structures that continually wrestle with contradictions.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—"), _c('em', [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Shacochis proves himself to be the rarest of contemporary American novelists, a writer with a worldview.... "), _c('em', [_vm._v("Swimming in the Volcano")]), _vm._v(" is a reminder of literature’s finest affirmation: that "), _c('em', [_vm._v("life")]), _vm._v(" itself is an exotic journey, a trip to an unknown island, a one-way ticket to the heart’s interior.”")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("—"), _c('em', [_vm._v("Conde Nast Traveler")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afe06e2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/otherfm.vue
// module id = 60
// module chunks = 0